import Tab from '@components/tabs/secondary'
import React, { Fragment } from 'react'
import Staff from './staff'
import ContactPerson from './contact-person'

const StaffManagement = ({ user }) => {
  const items = [
    { label: 'Staffs', component: Staff, props: { user } },
    { label: 'Contact Person', component: ContactPerson },
  ]
  return (
    <Fragment>
      <Tab items={items} />
    </Fragment>
  )
}

export default StaffManagement
